module.exports = __webpack_public_path__ + "static/img/t6.2801de03.png";